import { useTheme } from 'styled-components';

import AnnouncementBanner from './AnnouncementBanner';
import ExpirationBanner from './ExpirationBanner';

const Banner = () => {
	const theme = useTheme();

	if (theme.isTrialEnvironment) {
		return <ExpirationBanner />;
	}

	return <AnnouncementBanner />;
};

export default Banner;
